import Vue from 'vue'
import Router from 'vue-router'

import LogIn from '@/components/Admin/LogIn'
import NewUser from '@/components/Admin/NewUser'
import UserDetails from '@/components/Admin/UserDetails'
import PaperDetails from '@/components/Papers/PaperDetails'
import UserDashboard from '@/components/Admin/UserDashboard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn
    },
    {
      path: '/signup',
      name: 'NewUser',
      component: NewUser,
      beforeEnter: (to, from, next) => {
        const token = localStorage.getItem('app-token')
        if (!token) return next('/login')
        try {
          const userItem = JSON.parse(token)
          if (userItem && userItem.loginUser && userItem.loginUser.userType === 'admin') {
            return next()
          }
        } catch (e) {
          // invalid token
        }
        return next('/login')
      }
    },
    {
      path: '/papers/users/:id',
      name: 'UserDetails',
      component: UserDetails,
      props: true
    },
    {
      path: '/papers/details/:id',
      name: 'Paper Details',
      component: PaperDetails,
      props: true
    },
    {
      path: '/papers/:menu',
      name: 'Dashboard',
      component: UserDashboard,
      props: true
    },
    {
      path: '/',
      component: UserDashboard,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js